function isSameAddress (address1, address2) {

	// there are other properties that are different but don't matter for comparison
	// so let's just do a manual comparison to check if the 2 addresses are the same
	return (
		address1
		&& address2
		&& address1.FirstName === address2.FirstName
		&& address1.LastName === address2.LastName
		&& address1.AddressLine1 === address2.AddressLine1
		&& address1.AddressLine2 === address2.AddressLine2
		&& address1.City === address2.City
		&& address1.State === address2.State
		&& address1.Country === address2.Country
		&& address1.PostalCode === address2.PostalCode
		&& (address1.PhoneNumber === address2.PhoneNumber
			|| address1.Phone === address2.PhoneNumber
			|| address1.PhoneNumber === address2.Phone)
	);

}

export default isSameAddress;
